import React, { useState } from "react";
import './RightSidebar.css';
import { useIsMobile } from "./useIsMobile";


interface RightSidebarProps {
    children?: React.ReactNode;
}

const RightSidebar: React.FC<RightSidebarProps> = ({ children }) => {
    const isMobile = useIsMobile();
    const [isOpen] = useState(isMobile ? false : true);
    
    const shouldShowChildren = !isMobile || (isMobile && isOpen);
    
    return (
        <div className={`right-sidebar-wrapper ${isMobile ? 'mobile' : ''} ${isMobile && isOpen ? 'open-right-sidebar' : ''}`}>
            {shouldShowChildren && children}
            {/* {isMobile &&
            <div 
            className="right-sidebar-handle"
            onClick={() => setIsOpen(!isOpen)}
            >
                <FaArrowLeft/>
            </div>
            } */}
        </div>
    );
}

export default RightSidebar